export const getValTdContent = (dataKey: string, value: any) => {
    switch (dataKey) {
        case 'wSeq':
        case 'isResend':
            return JSON.stringify(value, null, 2)
        default:
            return value
    }
}

type GetDetailsArrayReturnValue = Array<{
    key: string
    value: any
    desc?: any
}>
type GetDetailsArray = (obj: Record<string, any>) => GetDetailsArrayReturnValue

export const getDetailsArray: GetDetailsArray = (obj) =>
    Object.entries(obj).reduce<GetDetailsArrayReturnValue>((prev, [key, value]) => {
        if (!Array.isArray(value) && typeof value === 'object') {
            return prev
        }
        if (key.includes('Desc') || key === 'msg' || key === '_id') {
            return prev
        }
        if (Array.isArray(value)) {
            return [...prev, ...value.reduce((prev, obj) => [...prev, ...getDetailsArray(obj)], [])]
        }
        return [
            ...prev,
            {
                key,
                value,
                desc: obj[`${key}_Desc`]
            }
        ]
    }, [])
